import { render, staticRenderFns } from "./DrawingRequestDetailsView.vue?vue&type=template&id=676bed43&scoped=true"
import script from "./DrawingRequestDetailsView.vue?vue&type=script&lang=ts"
export * from "./DrawingRequestDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./DrawingRequestDetailsView.vue?vue&type=style&index=0&id=676bed43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bed43",
  null
  
)

export default component.exports